import type { XYChartCustomTooltipProps } from '../types/xy-chart-props.js';

/**
 * @deprecated Use `XYChart.Tooltip` instead. The `CustomTooltip` slot will be removed in a future release.
 */
// TODO [APPDEV-17650] Remove CustomTooltip slot.
// oxlint-disable-next-line typescript/no-deprecated
export const CustomTooltip = (props: XYChartCustomTooltipProps) => null;

// oxlint-disable-next-line typescript/no-deprecated
CustomTooltip['displayName'] = 'XYChartChart.CustomTooltip';
